import { render, staticRenderFns } from "./connected-answer.vue?vue&type=template&id=2af5355d&scoped=true&"
import script from "./connected-answer.vue?vue&type=script&lang=js&"
export * from "./connected-answer.vue?vue&type=script&lang=js&"
import style0 from "./connected-answer.vue?vue&type=style&index=0&id=2af5355d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5355d",
  null
  
)

export default component.exports